import { isObject } from '../../../../../shared/helpers/is-object';
import {
    BroadcastDataPayload,
    ChatCreatedPayload,
    ConferenceStatePayload,
    MessageEventType,
    PassportAccountModificationPayload,
    PeersStatePayload,
    PermissionsModificationPayload,
    PermissionsStatePayload,
    RoleChangedPayload,
    SummarizationSettingsUpdatePayload,
} from '../../../types';

export function isChatCreatedPayload(value: unknown): value is ChatCreatedPayload {
    if (!value || !isObject(value)) {
        return false;
    }

    return 'chat_path' in value && typeof value.chat_path === 'string';
}

export function isRoleChangedPayload(value: unknown): value is RoleChangedPayload {
    if (!value || !isObject(value)) {
        return false;
    }

    return (
        'source' in value &&
        'event' in value &&
        isObject(value.event) &&
        'type' in value.event &&
        typeof value.event.type === 'string' &&
        value.event.type === MessageEventType.RoleChanged
    );
}

export function isPeersStatePayload(value: unknown): value is PeersStatePayload {
    if (!value || !isObject(value)) {
        return false;
    }

    return 'peers' in value && Array.isArray(value.peers);
}

export function isConferenceStatePayload(value: unknown): value is ConferenceStatePayload {
    if (!value || !isObject(value)) {
        return false;
    }

    return (
        'conference' in value &&
        isObject(value.conference) &&
        'state' in value.conference &&
        isObject(value.conference.state)
    );
}

export function isPermissionsStatePayload(value: unknown): value is PermissionsStatePayload {
    if (!value || !isObject(value)) {
        return false;
    }

    return 'permissions' in value && isObject(value.permissions);
}

export function isPassportAccountModificationPayload(value: unknown): value is PassportAccountModificationPayload {
    if (!value || !isObject(value)) {
        return false;
    }

    return 'peer_id' in value && typeof value.peer_id === 'string';
}

export function isBroadcastDataPayload(value: unknown): value is BroadcastDataPayload {
    if (!value || !isObject(value)) {
        return false;
    }

    return (
        'broadcast_data' in value &&
        isObject(value.broadcast_data) &&
        'status' in value.broadcast_data &&
        'broadcast_uri' in value.broadcast_data
    );
}

export function isPermissionsModificationPayload(value: unknown): value is PermissionsModificationPayload {
    if (!value || !isObject(value)) {
        return false;
    }

    return 'type' in value && typeof value.type === 'string' && value.type === 'permissions_modification';
}

export function isSummarizationSettingsUpdatePayload(value: unknown): value is SummarizationSettingsUpdatePayload {
    if (!value || !isObject(value)) {
        return false;
    }

    return 'type' in value && typeof value.type === 'string' && value.type === 'summarization_settings_update';
}
